import React from 'react'

import { useOverflowMenu } from '../hooks/overflowMenu'

const CrontabColumnFramework = (props) => {
  const { data, value, api } = props
  const OverflowMenu = useOverflowMenu({
    data,
    gridApi: api
  }) // TODO: Check permissions?

  return (
    <div className='progress-column'>
      <div className='flex-wrap cron-tab-exp'>{value}</div>
      <OverflowMenu />
    </div>
  )
}

export default CrontabColumnFramework
